<template>
  <TopNav></TopNav>
  <h1>Group Work Calculator</h1>
  <fieldset>
    <legend>Group Work Calculator</legend>
    <label for="a">Person A: </label> <input type="number" v-model.number="a" id="a" step="any"> hours
    <br>
    <label for="b">Person B: </label> <input type="number" v-model.number="b" id="b" step="any"> hours
    <br><br>
    A and B complete a work together in <span class="blue">{{ result() }} hours</span>.
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "GroupWork",
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 5
      }),
      a: 0,
      b: 0,
    }
  },
  components: {
    TopNav
  },
  methods: {
    result: function () {
      let hours = 1 / (1/this.a + 1/this.b);
      return this.formatter.format(hours);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 90px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
